// Presets: every tier and strategy that shipped, as a SAVED REQUEST.
//
// Nothing that was on the pad goes away. Low, Medium, High and Outrageous are
// one tap; so is each strategy. A preset is one or more requests to `answer`
// (Classic Four Ways is four of them, one per tier, the way its pad was), and
// the strategies whose opinion is a MODEL rather than a price — Elo, Dixon-Coles,
// Close chaser, Model crowd — cannot be said as a request at all, so they keep
// printing through the engine they always ran on (`legacy`), off the same board.

export const PRESETS = [
  { id: 'low', group: 'risk', label: 'Low', requests: [{ risk: 'low' }] },
  { id: 'medium', group: 'risk', label: 'Medium', requests: [{ risk: 'medium' }] },
  { id: 'high', group: 'risk', label: 'High', requests: [{ risk: 'high' }] },
  { id: 'outrageous', group: 'risk', label: 'Outrageous', requests: [{ risk: 'outrageous' }] },
  {
    id: 'classic-four-ways',
    group: 'strategy',
    label: 'Classic Four Ways',
    blurb: 'One multi per risk level, favourites',
    // One ticket per tier, favourites, the leg counts Classic always used.
    per: 1,
    requests: [
      { risk: 'low', strategy: 'likely', legs: 2 },
      { risk: 'medium', strategy: 'likely', legs: 3 },
      { risk: 'high', strategy: 'likely', legs: { min: 4, max: 5 } },
      { risk: 'outrageous', strategy: 'likely', legs: { min: 6, max: 8 } },
    ],
  },
  { id: 'market-edge', group: 'strategy', label: 'Market edge', blurb: 'Legs priced above the market', requests: [{ strategy: 'edge', legs: { min: 1, max: 5 } }] },
  { id: 'mispriced-odds', group: 'strategy', label: 'Mispriced odds', blurb: 'Singles priced above the market', requests: [{ strategy: 'edge', legs: 1 }] },
  {
    id: 'racing-all-up', group: 'strategy', label: 'Racing all-up', blurb: 'Racing only, likeliest runners',
    requests: [{ sports: [{ sport: 'racing', weight: 'only' }], strategy: 'likely', legs: { min: 2, max: 4 } }],
  },
  {
    id: 'racing-value', group: 'strategy', label: 'Racing value', blurb: 'Racing only, best value',
    requests: [{ sports: [{ sport: 'racing', weight: 'only' }], strategy: 'edge', legs: { min: 1, max: 4 } }],
  },
  {
    id: 'racing-mispriced', group: 'strategy', label: 'Racing mispriced', blurb: 'Racing singles priced above the market',
    requests: [{ sports: [{ sport: 'racing', weight: 'only' }], strategy: 'edge', legs: 1 }],
  },
  { id: 'elo-edge', group: 'model', label: 'Elo edge', blurb: 'Team ratings from past results', legacy: 'elo-edge' },
  { id: 'dixon-coles-edge', group: 'model', label: 'Dixon-Coles', blurb: 'A goals model for the Premier League', legacy: 'dixon-coles-edge' },
  { id: 'close-chaser', group: 'model', label: 'Close chaser', blurb: 'Prices expected to shorten before the start', legacy: 'close-chaser' },
  { id: 'model-crowd', group: 'model', label: 'Model crowd', blurb: 'Public AFL models, weighted by their record', legacy: 'model-crowd' },
];

export const presetById = (id) => PRESETS.find((p) => p.id === id) ?? null;

/**
 * A preset's requests with the punter's own chips laid over them: "Racing
 * value, but no greyhounds" is a preset plus a chip, and the chip wins.
 */
export function presetRequests(preset, overlay = {}) {
  if (!preset?.requests) return [];
  return preset.requests.map((r) => ({
    ...r,
    sports: [...(r.sports ?? []), ...(overlay.sports ?? [])],
    events: [...(r.events ?? []), ...(overlay.events ?? [])],
    bookmakers: [...(r.bookmakers ?? []), ...(overlay.bookmakers ?? [])],
    ...(overlay.when && overlay.when !== 'today' ? { when: overlay.when } : {}),
  }));
}
